import { normalize } from "normalizr";
import { takeEvery, channel } from "redux-saga";
import { put, take, call, fork } from "redux-saga/effects";
import fetchWithCSRFToken, { fetchWithCSRFTokenNoContentType } from "Utils/fetchWithCSRFToken";
import { convertDataToFormDataFormat, isFileOrContainsFile } from "Utils/formDataHelpers";

import { START_REQUEST, updateEntities, replace } from "./Actions";

import type { StartRequestAction } from "./Actions";

export function getJsonResponse(action: StartRequestAction) {
  let fetch;
  let body;

  if (isFileOrContainsFile(action.payload.body)) {
    fetch = fetchWithCSRFTokenNoContentType;
    body = convertDataToFormDataFormat(action.payload.body);
  } else {
    fetch = fetchWithCSRFToken;
    body = JSON.stringify(action.payload.body);
  }

  return fetch(action.payload.url, {
    method: action.payload.method || "get",
    body,
    processData: false,
  }).then((response) => {
    if (response.status >= 400) {
      return response.text().then((msg) => {
        throw new Error(`Request returned HTTP ${response.status} ${response.statusText}: ${msg}`);
      });
    }
    return response.json();
  });
}
export function* rootSaga(): Generator<any, any, any> {
  const dispatchChan = yield call(channel);
  yield fork(function* () {
    while (true) {
      const action = yield take(dispatchChan);
      yield put(action);
    }
  });

  const dispatch = (x) => dispatchChan.put(x);

  yield takeEvery(START_REQUEST, function* (action: StartRequestAction) {
    try {
      const rawResponse = yield call(getJsonResponse, action);
      let response = rawResponse;

      if (action.payload.responseKey) {
        if (!(action.payload.responseKey in response)) {
          throw new Error(`Invalid response key ${action.payload.responseKey}`);
        }

        response = response[action.payload.responseKey];
      }

      if (action.payload.responseSchema) {
        response = normalize(response, action.payload.responseSchema);
      }

      if (action.meta.replace) {
        yield put(replace(response));
      } else {
        yield put(updateEntities(response));
      }

      if (action.meta.onSuccess) {
        action.meta.onSuccess.call(null, rawResponse, dispatch, action.payload);
      }
    } catch (e) {
      if (action.meta.onFailure) {
        action.meta.onFailure.call(null, e, dispatch, action.payload);
      } else {
        console.error(e);
      }
    }
  });
}
